import { render, staticRenderFns } from "./VLeadRevisions.vue?vue&type=template&id=3a63bb12"
import script from "./VLeadRevisions.vue?vue&type=script&lang=js"
export * from "./VLeadRevisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports